import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { RequestStatus } from '../../models/requestStatus';
import { API } from 'src/app/configs';
import { Subscription } from 'rxjs';
import { RequestService } from '../../services/request.service';
import { DialogActionComponent } from '../dialog-action/dialog-action.component';

declare var $;

@Component({
  selector: 'dialog-authorization-list',
  templateUrl: 'dialog-authorization-list.component.html',
  styleUrls: ['./dialog-authorization-list.component.scss']
})
export class DialogAuthorizationListComponent implements OnInit, OnDestroy {

  list:any = [];
  total:any = {};
  loadingList = false;

  activeItem = null;

  error = false;

  page = 0;

  requestType:any = {};

  iconStatus:any = new RequestStatus().getIcons();

  protected transactionDataSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected als: AppLoadingService,
    protected httpService: HttpService,
    protected rs: RequestService,
  ) { 


    this.transactionDataSubscription = this.gs.transactionData.subscribe(result => {
      if(['request'].indexOf(result?.method) > -1 && result?.action == 'reload'){
        this.loadData(null, 1);
      }
    });

  }

  ngOnInit(){
    this.loadData(null, 1);
  }

  ngOnDestroy(){

  }

  
  async loadData(event = null, page:any = 'next') {

    this.page = page == 'next'? this.page + 1 : page;

    if(this.loadingList){
      if (event)
          event.target.complete();

      return;
    }

    this.error = false;
    this.loadingList = true;

    return await this.httpService.post<any>(API.person.general.authorization.listReceived, {
      current_page : this.page
    })
    .then(async (result) => {
      result.list = result.list.map(item => {
        item.avatar = this.gs.adjustAvatarFiles(item);
        item.avatarFiles = this.gs.getAvatarFile(item.avatar);

        item.payload = (typeof item?.payload === 'string' && item?.payload!='{}')? JSON.parse(item.payload): {};
        if(item.expiration){
          let dateExp:any = new Date(item.expiration);
          let dateToday:any = new Date();
          item.expiration+=' 00:00:00';
          item.expirated = (dateToday - dateExp) > 0;
        }
        return item;
      })

      this.list = this.page == 1? result.list : this.list.concat(result.list);
      this.total = result?.total || {};

    })
    .catch((error) => {
      this.error = true;
      this.list = [];
      this.gs.error(error);
    })
    .finally(() => {
      if (event)
        event.target.complete();

      this.loadingList = false;
    });
     
  }  

  imgDidLoad(event){
    this.gs.imgDidLoad(event);
  }

  async openMenu(event,data){
    this.activeItem = data;
    
    let buttons = [];

    buttons.push(
    {
        text: 'Visualizar autorização',
        icon: 'external-link',
        handler: () => {
            window.open(data.file_url,'_system', 'location=yes');
        }
    });

    buttons.push(
    {
            text: 'Copiar link do PDF',
            icon: 'copy',
        handler: () => {
            const el = document.createElement('textarea');
            el.value = data?.file_url || data?.authorization_file_url;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.gs.message('Link copiado');
        }
    });

    buttons.push(
    {
        text: 'Perfil da empresa',
        icon: 'briefcase',
        handler: () => {
            this.gs.openProfile(event, data?.public_idtext, {admin:false});
        }
    });

    if(data?.ad_id)
    buttons.push(
        {
            text: 'Visualizar anúncio',
            icon: 'external-link',
            handler: () => {
                this.gs.navigate(['openModal', 'ViewComponentAd', data?.friendlyTitle]);
            }
    });
    
    buttons.push({
        text: 'Fechar',
        icon: 'times',
        role: 'cancel',
        handler: () => {
        }
      }
    );

    let modalId = 'DialogActionComponent_'+Math.random();

    const dialogRef = this.dialog.open(DialogActionComponent, 
        {
            id:modalId,
            data: {
                modalId: modalId,
                title:'Clique na ação desejada',
                cancelNotShow:true,
                okNotShow:true,
                buttons : buttons
            }
        });

      dialogRef.afterClosed().subscribe(result => {
        if(result)
            console.log(result);
          //this.save(action, null);
      });
  }

}